<template lang='pug'>
  #homepage.c-content(@click="closePopup")

    HomepageBanner.c-section(ref="homeBanner")

    MenuTop(ref="menu")

    .c-section
      .bgColor-gray
        WhdBlock
        WhdProductBlock
      .bgColor-white
        WellveBlock
      .bgColor-gray
        WellveLogoBlock
      .bgColor-white
        Pressalit
        PressalitList
        WiboBlock
        DietzBlock
        StiglerBlock

    .c-section
      AboutUs
    .c-section
      TeamWork
    .c-section
      ContactUs
      ContactForm
    Footer

</template>

<script>
  // import api from '@/api'
  // import axios from 'axios'
  import HomepageBanner from '@/components/layout/content/homepageBanner.vue'
  import MenuTop from '@/components/menu/menu.vue'
  import WhdBlock from '@/components/layout/trademark/whd.vue'
  import WhdProductBlock from '@/components/layout/trademark/whdProduct.vue'
  import WellveBlock from '@/components/layout/trademark/wellve.vue'
  import WellveLogoBlock from '@/components/layout/trademark/wellveLogo.vue'
  import Pressalit from '@/components/layout/trademark/pressalit.vue'
  import PressalitList from '@/components/layout/trademark/pressalitList.vue'
  import WiboBlock from '@/components/layout/trademark/wibo.vue'
  import DietzBlock from '@/components/layout/trademark/dietz.vue'
  import StiglerBlock from '@/components/layout/trademark/stigler.vue'
  import AboutUs from '@/components/layout/content/aboutUs.vue'
  import TeamWork from '@/components/layout/content/teamWork.vue'
  import ContactUs from '@/components/layout/content/contactUs.vue'
  import ContactForm from '@/components/layout/content/contactForm.vue'
  import Footer from '@/components/footer/footer.vue'

  export default {
    name: 'homepage',
    components: {
      HomepageBanner,
      MenuTop,
      WhdBlock,
      WhdProductBlock,
      WellveBlock,
      WellveLogoBlock,
      Pressalit,
      PressalitList,
      WiboBlock,

      DietzBlock,
      StiglerBlock,
      AboutUs,
      TeamWork,
      ContactUs,
      ContactForm,
      Footer,
      'q-parallax': Quasar.QParallax,
    },
    data(){
      return {
        scrollNum: null,
      }
    },
    computed: {
      menuHeight(){
        return this.$refs.menu.$el.offsetHeight
      }
    },
    mounted() {
      window.addEventListener('scroll', this.dataScroll)
      // if(this.$route.query && this.$route.query.id) {
      //   // this.jumpToScroll(this.$route.query.id)
      //   this.scrollNum = this.$route.query.id
      // }
    },
    created() {},
    methods: {
      dataScroll() {
        this.scrollNum = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset
        if (this.scrollNum > 0) {
          if (this.$refs.menu && this.$refs.menu.languageActive && this.$refs.menu.languageActive == true) {
            this.$refs.menu.closeLanguageChild()
          } else if (this.$refs.homeBanner && this.$refs.homeBanner.languageActive && this.$refs.homeBanner.languageActive == true) {
            this.$refs.homeBanner.closeLanguageChild()
          }
        }
      },
      jumpToScroll(index) {
        let section = document.getElementsByClassName('c-section')
        let total = section[index].offsetTop - this.menuHeight
        if (this.Common.IEVersion() != -1) {
          window.scrollTo(0, total)
        } else {
          window.scrollTo({
            top: total,
            behavior: "smooth"
          })
        }
      },
      loadScroll() {
        let sections = document.getElementsByClassName('c-section')
        for (let i = sections.length - 1; i >= 0; i--) {
          if (this.scrollNum >= sections[i].offsetTop - this.menuHeight) {
            this.$refs.menu.navActive = i
            return
          }
        }
      },
      routeTo(link, index){
        this.$router.push({
          name: link,
          query: {
            id: index
          }
        })
      },

      closePopup(){
        if (this.$refs.menu && this.$refs.menu.languageActive && this.$refs.menu.languageActive == true) {
          this.$refs.menu.closeLanguageChild()
        }
        if (this.$refs.homeBanner && this.$refs.homeBanner.languageActive && this.$refs.homeBanner.languageActive == true) {
          this.$refs.homeBanner.closeLanguageChild()
        }
      }
    },
    watch: {
      scrollNum: function () {
        this.loadScroll()
      }
    },
  }
</script>
